import React, { useState } from "react";
import appLogo from "../../../../assets/images/nip-ext-logo4.png";
import signInImage from "../../../../assets/images/Rectangle9.png";
import signInBtn from "../../../../assets/images/Button.png";
import { BiLoaderCircle } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useUserLoggedin } from "../../../../state/state";
import makeYoutubeWork from "../../../../assets/images/We Make YouTube Work for Businesses.png";
import UserConsentPanel from "../../../UserAuth/components/UserConsentPanel";
import { ThemeContext } from "../../../../themes/ThemeContext";
import showToast from "../../../../utils/toastUtils";
import { registerPartner } from "../../../../data/api/api";

const SignUpTemplate = () => {
  const theme = React.useContext(ThemeContext);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    password: "",
    business_name: "",
    webhookUrl: "",
    confirmPassword: "",
    agreeToTerms: false,
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showUserConsentPanel, setShowUserConsentPanel] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const setUserLoggedIn = useUserLoggedin((state) => state.setUserLoggedIn);
  const navigate = useNavigate();

  

  // Validation functions
  const validateForm = () => {
    const errors = {};

    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      errors.email = "Invalid email format";
    }

    if (!formData.phone) {
      errors.phone = "Phone number is required";
    } else if (!/^\+?\d{10,15}$/.test(formData.phone)) {
      errors.phone = "Invalid phone number format";
    }

    if (!formData.password) {
      errors.password = "Password is required";
    } else if (formData.password.length < 8) {
      errors.password = "Password must be at least 8 characters";
    }

    if (!formData.first_name) {
      errors.first_name = "First Name is required";
    }

    if (!formData.last_name) {
      errors.last_name = "Last Name is required";
    }

    if (!formData.webhookUrl) {
      errors.webhookUrl = "Webhook url is required";
    }

    if (!formData.business_name) {
      errors.business_name = "Business name is required";
    }

    if (!formData.confirmPassword) {
      errors.confirmPassword = "Confirm Password is required";
    } else if (formData.confirmPassword !== formData.password) {
      errors.confirmPassword = "Passwords do not match";
    }

    if (!formData.agreeToTerms) {
      errors.agreeToTerms = "You must agree to the terms";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async () => {
    // if (!validateForm()) {
    //   return;
    // }

    setIsLoading(true);

    try {
      const data = await registerPartner(formData);

      if (data.status === "success") {
        localStorage.setItem("app_key", data.app_key);
        localStorage.setItem("userLoggedin", "true");
        localStorage.setItem("userFirstName", formData.first_name);
        setUserLoggedIn(true);
        showToast("success", data.message, 3000);
        // navigate("/dashboard");
      } else if (data.status === "warning") {
        localStorage.setItem("app_key", data.app_key);
        localStorage.setItem("userLoggedin", "true");
        localStorage.setItem("userFirstName", formData.first_name);
        setUserLoggedIn(true);
        showToast("warning", data.message, 3000);
      } else {
        showToast("error", data.message, 3000);
      }
    } catch (error) {
      showToast("error", "Unexpected error occurred. Please try again.", 3000);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      className="min-h-screen flex justify-center"
      style={{
        backgroundColor: theme.colors.background.primary,
        color: theme.colors.text.primary,
      }}
    >
      <div
        className="max-w-screen-xl w-full m-0 sm:m-10 bg-white shadow sm:rounded-lg flex-1 flex relative"
        style={{
          backgroundColor: theme.colors.background.secondary,
          color: theme.colors.text.primary,
        }}
      >
        <div className="w-1/2 p-6 mx-auto flex flex-col items-center justify-center">
          <div className="flex items-center justify-start w-full">
            <img
              src={appLogo}
              className="w-32 absolute top-5 left-5"
              alt="logo"
            />
          </div>
          <div className="mt-12 flex flex-col items-center">
            <h1 className="text-xl xl:text-3xl font-extrabold">
              Create Account
            </h1>
            <div
              className="flex gap-2 w-full justify-center mt-3 py-1 px-4 rounded-full"
              style={{
                backgroundColor: theme.colors.background.primary,
                color: theme.colors.text.primary,
                border: `1px solid ${theme.colors.background.accent}`,
              }}
            >
              <div className="text-xs mb-1 ml-1 text-gray-500">
                Account Type :
              </div>
              <span className="text-xs font-medium uppercase">Partner</span>
            </div>
            <div className="w-full flex-1 mt-8">
              <div className="mx-auto max-w-xs">
                <div className="flex items-center gap-3 justify-between">
                  <div className="flex flex-col">
                    <div className="text-xs mb-1 ml-1 text-gray-500">
                      First Name
                    </div>
                    <input
                      className={`w-full px-8 mb-5 py-4 rounded-full font-medium text-xs bg-gray-100 border ${
                        validationErrors.first_name
                          ? "border-red-500"
                          : "border-gray-200"
                      } placeholder-gray-500 text-xs focus:outline-none focus:border-gray-400 focus:bg-white`}
                      type="text"
                      placeholder="John"
                      value={formData.first_name}
                      onChange={(e) => {
                        setFormData({ ...formData, first_name: e.target.value });
                        setValidationErrors({
                          ...validationErrors,
                          first_name: "",
                        });
                      }}
                      style={{
                        backgroundColor: theme.colors.background.primary,
                        color: theme.colors.text.primary,
                        border: `1px solid ${theme.colors.background.accent}`,
                      }}
                    />
                    {validationErrors.first_name && (
                      <div className="text-red-500 text-xs mt-1">
                        {validationErrors.first_name}
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col">
                    <div className="text-xs mb-1 ml-1 text-gray-500">
                      Last Name
                    </div>
                    <input
                      className={`w-full px-8 py-4 mb-5 rounded-full font-medium bg-gray-100 border text-xs ${
                        validationErrors.last_name
                          ? "border-red-500"
                          : "border-gray-200"
                      } placeholder-gray-500 text-xs focus:outline-none focus:border-gray-400 focus:bg-white`}
                      type="text"
                      placeholder="Doe"
                      value={formData.last_name}
                      onChange={(e) => {
                        setFormData({ ...formData, last_name: e.target.value });
                        setValidationErrors({
                          ...validationErrors,
                          last_name: "",
                        });
                      }}
                      style={{
                        backgroundColor: theme.colors.background.primary,
                        color: theme.colors.text.primary,
                        border: `1px solid ${theme.colors.background.accent}`,
                      }}
                    />
                    {validationErrors.last_name && (
                      <div className="text-red-500 text-xs mt-1">
                        {validationErrors.last_name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="text-xs mb-1 ml-1 text-gray-500">Email</div>
                <input
                  className={`w-full px-8 py-4 mb-5 rounded-full font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-xs focus:outline-none focus:border-gray-400 focus:bg-white ${
                    validationErrors.email ? "border-red-500" : "border-gray-200"
                  }`}
                  type="email"
                  placeholder="youremail@email.com"
                  value={formData.email}
                  onChange={(e) => {
                    setFormData({ ...formData, email: e.target.value });
                    setValidationErrors({ ...validationErrors, email: "" });
                  }}
                  style={{
                    backgroundColor: theme.colors.background.primary,
                    color: theme.colors.text.primary,
                    border: `1px solid ${theme.colors.background.accent}`,
                  }}
                />
                {validationErrors.email && (
                  <div className="text-red-500 text-xs mt-1">
                    {validationErrors.email}
                  </div>
                )}

                <div className="text-xs mb-1 ml-1 text-gray-500">Phone</div>
                <input
                  className={`w-full px-8 py-4 mb-5 rounded-full font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-xs focus:outline-none focus:border-gray-400 focus:bg-white ${
                    validationErrors.phone ? "border-red-500" : "border-gray-200"
                  }`}
                  type="tel"
                  placeholder="+1234567890"
                  value={formData.phone}
                  onChange={(e) => {
                    setFormData({ ...formData, phone: e.target.value });
                    setValidationErrors({ ...validationErrors, phone: "" });
                  }}
                  style={{
                    backgroundColor: theme.colors.background.primary,
                    color: theme.colors.text.primary,
                    border: `1px solid ${theme.colors.background.accent}`,
                  }}
                />
                {validationErrors.phone && (
                  <div className="text-red-500 text-xs mt-1">
                    {validationErrors.phone}
                  </div>
                )}

                <div className="text-xs mb-1 ml-1 text-gray-500">Business Name</div>
                <input
                  className={`w-full px-8 py-4 mb-5 rounded-full font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-xs focus:outline-none focus:border-gray-400 focus:bg-white ${
                    validationErrors.business_name ? "border-red-500" : "border-gray-200"
                  }`}
                  type="text"
                  placeholder="Enter your business name"
                  value={formData.business_name}
                  onChange={(e) => {
                    setFormData({ ...formData, business_name: e.target.value });
                    setValidationErrors({ ...validationErrors, business_name: "" });
                  }}
                  style={{
                    backgroundColor: theme.colors.background.primary,
                    color: theme.colors.text.primary,
                    border: `1px solid ${theme.colors.background.accent}`,
                  }}
                />
                {validationErrors.business_name && (
                  <div className="text-red-500 text-xs mt-1">
                    {validationErrors.business_name}
                  </div>
                )}


                <div className="text-xs mb-1 ml-1 text-gray-500">Webhook URL</div>
                <input
                  className={`w-full px-8 py-4 mb-5 rounded-full font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-xs focus:outline-none focus:border-gray-400 focus:bg-white ${
                    validationErrors.webhookUrl ? "border-red-500" : "border-gray-200"
                  }`}
                  type="url"
                  placeholder="https://example.com/webhook"
                  value={formData.webhookUrl}
                  onChange={(e) => {
                    setFormData({ ...formData, webhookUrl: e.target.value });
                    setValidationErrors({ ...validationErrors, webhookUrl: "" });
                  }}
                  style={{
                    backgroundColor: theme.colors.background.primary,
                    color: theme.colors.text.primary,
                    border: `1px solid ${theme.colors.background.accent}`,
                  }}
                />
                {validationErrors.webhookUrl && (
                  <div className="text-red-500 text-xs mt-1">
                    {validationErrors.webhookUrl}
                  </div>
                )}

                <div className="flex items-center gap-3 justify-between">
                  <div className="flex flex-col">
                    <div className="text-xs mb-1 ml-1 text-gray-500">
                      Password
                    </div>
                    <div className="relative">
                      <input
                        className={`w-full px-8 mb-5 py-4 rounded-full font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-xs focus:outline-none focus:border-gray-400 focus:bg-white ${
                          validationErrors.password
                            ? "border-red-500"
                            : "border-gray-200"
                        }`}
                        type={showPassword ? "text" : "password"}
                        placeholder="********"
                        value={formData.password}
                        onChange={(e) => {
                          setFormData({ ...formData, password: e.target.value });
                          setValidationErrors({
                            ...validationErrors,
                            password: "",
                          });
                        }}
                        style={{
                          backgroundColor: theme.colors.background.primary,
                          color: theme.colors.text.primary,
                          border: `1px solid ${theme.colors.background.accent}`,
                        }}
                      />
                      <span
                        className="absolute top-4 right-3 cursor-pointer"
                        onClick={toggleShowPassword}
                      >
                        {showPassword ? (
                          <FaEyeSlash color="#7438FF" />
                        ) : (
                          <FaEye color="#7438FF" />
                        )}
                      </span>
                    </div>
                    {validationErrors.password && (
                      <div className="text-red-500 text-xs mt-1">
                        {validationErrors.password}
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col">
                    <div className="text-xs mb-1 ml-1 text-gray-500">
                      Confirm Password
                    </div>
                    <div className="relative">
                      <input
                        className={`w-full px-8 mb-5 py-4 rounded-full font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-xs focus:outline-none focus:border-gray-400 focus:bg-white ${
                          validationErrors.confirmPassword
                            ? "border-red-500"
                            : "border-gray-200"
                        }`}
                        type={showPassword ? "text" : "password"}
                        placeholder="********"
                        value={formData.confirmPassword}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            confirmPassword: e.target.value,
                          });
                          setValidationErrors({
                            ...validationErrors,
                            confirmPassword: "",
                          });
                        }}
                        style={{
                          backgroundColor: theme.colors.background.primary,
                          color: theme.colors.text.primary,
                          border: `1px solid ${theme.colors.background.accent}`,
                        }}
                      />
                      <span
                        className="absolute top-4 right-3 cursor-pointer"
                        onClick={toggleShowPassword}
                      >
                        {showPassword ? (
                          <FaEyeSlash color="#7438FF" />
                        ) : (
                          <FaEye color="#7438FF" />
                        )}
                      </span>
                    </div>
                    {validationErrors.confirmPassword && (
                      <div className="text-red-500 text-xs mt-1">
                        {validationErrors.confirmPassword}
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex items-start justify-start mb-5">
                  <label className="flex items-center cursor-pointer">
                    <input
                      className="w-4 h-4 mr-2 cursor-pointer text-xs"
                      type="checkbox"
                      checked={formData.agreeToTerms}
                      onChange={() => {
                        setFormData({
                          ...formData,
                          agreeToTerms: !formData.agreeToTerms,
                        });
                        setValidationErrors({
                          ...validationErrors,
                          agreeToTerms: "",
                        });
                      }}
                    />
                    <span
                      className={`text-xs font-medium ${
                        validationErrors.agreeToTerms ? "text-red-500" : ""
                      }`}
                    >
                      I agree to abide by NIPEXT's{" "}
                      <a
                        className="underline text-blue-800"
                        href={`#`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms of Service
                      </a>{" "}
                      and{" "}
                      <a
                        className="underline text-blue-800"
                        href={`#`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        privacy policy
                      </a>
                    </span>
                  </label>
                </div>
                {validationErrors.agreeToTerms && (
                  <div className="text-red-500 text-xs mt-1">
                    {validationErrors.agreeToTerms}
                  </div>
                )}

                <div className="flex items-center justify-between">
                  <div className="flex items-center justify-between">
                    {isLoading ? (
                      <img
                        src={signInBtn}
                        alt="Sign in Button"
                        className="h-8 cursor-not-allowed"
                        style={{ filter: "grayscale(1)" }}
                      />
                    ) : (
                      <img
                        src={signInBtn}
                        alt="Sign in Button"
                        className="h-8 cursor-pointer"
                        style={{
                          filter: `${
                            formData.email === "" || formData.password === ""
                              ? "grayscale(1)"
                              : ""
                          }`,
                        }}
                        onClick={handleSubmit}
                      />
                    )}
                    {isLoading && (
                      <BiLoaderCircle
                        className="animate-spin text-center ml-3"
                        color="#9999FF"
                        size={20}
                      />
                    )}
                  </div>
                </div>

                <div className="my-12 text-center">
                  <Link
                    to="/sign-in"
                    className="leading-none px-2 inline-block text-sm tracking-wide font-medium transform translate-y-1/2 mb-5"
                    style={{ color: theme.colors.text.primary }}
                  >
                    Or Log in Here
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-1/2 relative" style={{ backgroundColor: "#000015" }}>
          <div>
            <img
              src={signInImage}
              alt=""
              className="h-96 absolute top-0 right-0"
            />
          </div>
          <div>
            <img
              src={makeYoutubeWork}
              alt=""
              className="absolute bottom-16 left-32 ml-16"
            />
          </div>
        </div>
      </div>
      {showUserConsentPanel && (
        <UserConsentPanel
          setShowUserConsentPanel={setShowUserConsentPanel}
          formData={formData}
          setFormData={setFormData}
        />
      )}
    </div>
  );
};

export default SignUpTemplate;